import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toast } from 'react-toastify';
import autobind from 'autobind-decorator';

import HFMModal from '../hfm-modal';
import EditImage from '../edit-image';
import FieldFactory from '../field-factory';
import SongSelector from '../song-selector';

@inject('playlistStore', 'songsStore', 'formStore')
@observer
class PlaylistModal extends Component {
	state = {
		isModalOpen: false
	}

	render () {
		const {
			playlistStore,
			buttonLabel = '',
			buttonClassName = 'add-button button',
			icon = 'pencil'
		} = this.props;

		return (
			<div>
				<HFMModal
					isOpen={ this.state.isModalOpen }
					contentLabel="Edit Playlist"
				>
					<div className="modal-content" data-ta="playlistModal">
						<div className="grid-x">
							<div className="cell">
								{ this.renderMainContent() }
							</div>
						</div>

						<div className="modal-button-group">
							<button
								data-ta="closePlaylistModalBtn"
								className="button clear secondary"
								onClick={ this.handleCloseModal }
							>
								Close Modal
							</button>
							<button
								data-ta="savePlaylistModalBtn"
								className="button clear primary-color"
								onClick={ this.onClick }
							>
								Save
							</button>
						</div>
					</div>
				</HFMModal>

				<button
					data-ta="addPlaylistBtn"
					className={ buttonClassName }
					onClick={ this.handleOpenModal }
				>
					<span className={ `icon fi-${icon} margin-0` }></span> { buttonLabel }
				</button>
			</div>
		);
	}

	getField () {
		const { playlistStore: store, formStore } = this.props;
		const playlist = this.getPlaylist();
		const { id: dataId } = playlist;

		return (props) => {
			const propsObj = { formStore, store };

			if (_.isEmpty(dataId) !== true) {

				Object.assign(propsObj, { dataId });
			}

			return (
				<FieldFactory { ...props } { ...propsObj } />
			);
		}
	}

	renderMainContent () {
		const {
			playlistStore,
			formStore,
			songsStore,
			isHFMRadio = false,
			isHFMPicks = false
		} = this.props;

		const playlist = this.getPlaylist();
		const Field = this.getField();

		return (
			<div className="grid-x grid-padding-x">
				<div className="cell small-12" data-ta="playlistTitleInputContainer">
					<Field fieldKey="playlist.title" />
				</div>

				<div className="cell small-4">
					<EditImage
						imgSrc={ playlist.artwork }
						store={ playlistStore }
						width="383"
						height="254"
						aspectRatio={ 1.5 }
						imgClassName="image medium playlist"
						handleImageCrop={ this.handleImageCrop }
					/>
				</div>

				<div className="cell small-8">
					<Field
						floatLabel
						fieldKey="playlist.isHFMRadio"
						defaultValue={ isHFMRadio }
					/>
					<Field
						floatLabel
						fieldKey="playlist.isHFMPicks"
						defaultValue={ isHFMPicks }
					/>
				</div>

				<div className="cell small-12 text-left">
					<SongSelector
						addSong={ this.addSong }
						removeSong={ this.removeSong }
						onDragEnd={ this.reorderPlaylist }
						songList={ songsStore.songs }
						selectedSongs={ songsStore.getSongByID(playlist.songs) || [] }
					/>
				</div>
			</div>
		);
	}

	getPlaylist () {
		const { playlistStore } = this.props;
		const { playlist = playlistStore.data.playlist.toPOJO() } = this.props;

		playlistStore.set({
			key: 'playlist.isHFMRadio',
			value: true
		});

		return playlist;
	}

	@autobind
	addSong (songID) {
		const { playlistStore } = this.props;
		const { id } = this.getPlaylist();
		playlistStore.addSongToPlaylist(id, songID);
	}

	@autobind
	removeSong (songID) {
		const { playlistStore } = this.props;
		const { id } = this.getPlaylist();
		playlistStore.removeSongFromPlaylist(id, songID);
	}

	@autobind
	reorderPlaylist (dropResult) {
		const { playlistStore } = this.props;
		const { id } = this.getPlaylist();
		playlistStore.reorderPlaylist(dropResult, id);
	}

	@autobind
	onClick () {
		const { playlistStore } = this.props;
		const playlist = this.getPlaylist();

		if (playlist.id) {

			playlistStore.updatePlaylist(playlist);
			return;
		}

		playlistStore.savePlaylist();
	}

	@autobind
	handleOpenModal () {
		this.setState({
			isModalOpen: true
		});
	}

	@autobind
	handleCloseModal () {
		this.setState({
			isModalOpen: false
		});
	}

	@autobind
	async handleImageCrop (imgData) {
		const { playlistStore, playlist } = this.props;
		const { id } = this.getPlaylist();

		if (_.isEmpty(id)) {

			playlist.imgData = imgData;
			return;
		}

		await playlistStore.savePlaylistArtwork({ id, imgData }, {
			silent: true
		});
	}
}

export default PlaylistModal;
